import React, { useEffect, useRef, useState } from 'react';
import { Card, Table } from 'react-bootstrap';
import styled from 'styled-components';
import { isObject } from 'helpers/general';
import ReactPaginate from 'react-paginate';

export const CustomTD = styled.td`
	text-align: center;
`;

const StyledCard = styled(Card)`
	border: 1px solid black;
	border-radius: 14px;
	padding: 8px 0 0 0;
	width: ${(props) => (props.tablewidth ? props.tablewidth : 'inherit')};
	max-height: ${(props) => (props.maxheight ? props.maxheight : 'inherit')};
	overflow-y: ${(props) => (props.maxheight ? 'auto' : 'inherit')};
	overflow-x: auto;

	table {
		width: ${(props) => (props.tablewidth ? props.tablewidth : 'inherit')};
		thead{
			border-bottom: 1px solid black;
		}
		tbody {
			td {
				text-align: center;
			}
		}
	}
`;

const MyTable = styled(Table)`
	table-layout: fixed;
`;

const TH = styled.th`
	width: ${(props) => props.w ? props.w : 'inherit'};
`;

const PaginationHolder = styled.div`
	display: flex;
	justify-content: center;
	margin: 1rem 0 0.5rem 0;
`;

const CommonTable = ({
	cols,
	children,
	tablewidth,
	maxHeight,
	pageOffset = 0,
	pageCount = 0,
	fetchPageAt,
}) => {
	const ref = useRef();

	useEffect(() => {
		const domNode = ref.current;
		if (domNode) {
			domNode.scrollLeft = domNode.scrollWidth;
		}
	}, []);

	// useEffect(() => {
	// 	// fetchPageAt?.(pageOffset + 1);
	// 	console.log(`useEffect -- pageOffset: ${pageOffset}`);
	// }, [pageOffset]);

	const handlePageChange = (event) => {
		const newOffset = parseInt(event.selected);
		// console.log(`handlePageChange(${newOffset})`);		
		fetchPageAt?.(newOffset + 1);
		// setPageOffset(newOffset);
	};

	return (
		<StyledCard ref={ref} tablewidth={tablewidth} maxheight={maxHeight}>
			<MyTable borderless>
				<thead className="w-100">
					<tr className="text-center">
						{cols.length > 0 &&
							cols.map((col, i) => (
								<TH key={i} w={isObject(col) ? col.width : null}>
									{isObject(col) ? col.title : col}
								</TH>
							))}
					</tr>
				</thead>
				<tbody>{children}</tbody>
			</MyTable>
			{(pageCount > 1) && (
				<PaginationHolder>
					<ReactPaginate
						previousLabel="قبلی"
						nextLabel="بعدی"
						pageClassName="page-item"
						pageLinkClassName="page-link"
						previousClassName="page-item"
						previousLinkClassName="page-link"
						nextClassName="page-item"
						nextLinkClassName="page-link"
						breakLabel="..."
						breakClassName="page-item"
						breakLinkClassName="page-link"
						pageCount={pageCount}
						marginPagesDisplayed={2}
						pageRangeDisplayed={5}
						onPageChange={handlePageChange}
						containerClassName="pagination"
						activeClassName="active"
						forcePage={pageOffset}
					/>
				</PaginationHolder>
			)}
		</StyledCard>
	);
};

export default CommonTable;
